import { MainLayout } from "@components/layouts/MainLayout";
import { User } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import { PlaceHolder } from "@components/settings/account/PlaceHolder";

export default function General() {
  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<User className="h-6 w-6 text-blue-600" />}
            title="Account"
            subtitle="Configure your account settings."
          />
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <PlaceHolder />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
